import { render, staticRenderFns } from "./SettlementSearch.vue?vue&type=template&id=04db34bc&scoped=true"
import script from "./SettlementSearch.vue?vue&type=script&lang=js"
export * from "./SettlementSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db34bc",
  null
  
)

export default component.exports